import util from '../util';

export const PEN_REGISTER = 'PEN_REGISTER';
export const PROVIDERS = 'PROVIDERS';
export const PRODUCTS = 'PRODUCTS';
export const PROVIDER_PRODUCTS = 'PROVIDER_PRODUCTS';
export const CREATE_PRODUCT = 'CREATE_PRODUCT';
export const EDIT_PRODUCT = 'EDIT_PRODUCT';
export const DISABLE_PRODUCTS = 'DISABLE_PRODUCTS';
export const INIT_PEN_CONFIG = 'INIT_PEN_CONFIG';
export const SET_PEN_CONFIG = 'SET_PEN_CONFIG';
export const ADD_PROVIDER_TO_DEALER = 'ADD_PROVIDER_TO_DEALER';
export const GET_BUNDLE = 'GET_BUNDLE';
export const CREATE_BUNDLE = 'CREATE_BUNDLE';
export const EDIT_BUNDLE = 'EDIT_BUNDLE';
export const GET_AVAIL_PRODUCTS_FOR_BUNDLE = 'GET_AVAIL_PRODUCTS_FOR_BUNDLE';
export const REGISTER_PRODUCT_DEALER_CODE = 'REGISTER_PRODUCT_DEALER_CODE';
export const REGISTER_PROVIDER_DEALER_CODE = 'REGISTER_PROVIDER_DEALER_CODE';
export const REGISTER_PRODUCT_AND_GET_COVERAGES =
  'REGISTER_PRODUCT_AND_GET_COVERAGES';
export const GET_COVERAGES_AND_DEDUCTIBLES = 'GET_COVERAGES_AND_DEDUCTIBLES';

export const RESET_COVERAGES_AND_DEDUCTIBLES =
  'RESET_COVERAGES_AND_DEDUCTIBLES';

export const PEN_REGISTER_REQUEST = util.requestType(PEN_REGISTER);
export const PEN_REGISTER_SUCCESS = util.successType(PEN_REGISTER);
export const PEN_REGISTER_FAILURE = util.failureType(PEN_REGISTER);

export const PRODUCTS_REQUEST = util.requestType(PRODUCTS);
export const PRODUCTS_SUCCESS = util.successType(PRODUCTS);
export const PRODUCTS_FAILURE = util.failureType(PRODUCTS);

export const PROVIDER_PRODUCTS_REQUEST = util.requestType(PROVIDER_PRODUCTS);
export const PROVIDER_PRODUCTS_SUCCESS = util.successType(PROVIDER_PRODUCTS);
export const PROVIDER_PRODUCTS_FAILURE = util.failureType(PROVIDER_PRODUCTS);

export const CREATE_PRODUCT_REQUEST = util.requestType(CREATE_PRODUCT);
export const CREATE_PRODUCT_SUCCESS = util.successType(CREATE_PRODUCT);
export const CREATE_PRODUCT_FAILURE = util.failureType(CREATE_PRODUCT);

export const EDIT_PRODUCT_REQUEST = util.requestType(EDIT_PRODUCT);
export const EDIT_PRODUCT_SUCCESS = util.successType(EDIT_PRODUCT);
export const EDIT_PRODUCT_FAILURE = util.failureType(EDIT_PRODUCT);

export const DISABLE_PRODUCTS_REQUEST = util.requestType(DISABLE_PRODUCTS);
export const DISABLE_PRODUCTS_SUCCESS = util.successType(DISABLE_PRODUCTS);
export const DISABLE_PRODUCTS_FAILURE = util.failureType(DISABLE_PRODUCTS);

export const BUNDLE_REQUEST = util.requestType(GET_BUNDLE);
export const BUNDLE_SUCCESS = util.successType(GET_BUNDLE);
export const BUNDLE_FAILURE = util.failureType(GET_BUNDLE);

export const EDIT_BUNDLE_REQUEST = util.requestType(EDIT_BUNDLE);
export const EDIT_BUNDLE_SUCCESS = util.successType(EDIT_BUNDLE);
export const EDIT_BUNDLE_FAILURE = util.failureType(EDIT_BUNDLE);

export const CREATE_BUNDLE_REQUEST = util.requestType(CREATE_BUNDLE);
export const CREATE_BUNDLE_SUCCESS = util.successType(CREATE_BUNDLE);
export const CREATE_BUNDLE_FAILURE = util.failureType(CREATE_BUNDLE);

export const PROVIDERS_REQUEST = util.requestType(PROVIDERS);
export const PROVIDERS_SUCCESS = util.successType(PROVIDERS);
export const PROVIDERS_FAILURE = util.failureType(PROVIDERS);

export const INIT_PEN_CONFIG_REQUEST = util.requestType(INIT_PEN_CONFIG);
export const INIT_PEN_CONFIG_SUCCESS = util.successType(INIT_PEN_CONFIG);
export const INIT_PEN_CONFIG_FAILURE = util.failureType(INIT_PEN_CONFIG);

export const SET_PEN_CONFIG_REQUEST = util.requestType(SET_PEN_CONFIG);
export const SET_PEN_CONFIG_SUCCESS = util.successType(SET_PEN_CONFIG);
export const SET_PEN_CONFIG_FAILURE = util.failureType(SET_PEN_CONFIG);

export const GET_COVERAGES_AND_DEDUCTIBLES_REQUEST = util.requestType(
  GET_COVERAGES_AND_DEDUCTIBLES,
);
export const GET_COVERAGES_AND_DEDUCTIBLES_SUCCESS = util.successType(
  GET_COVERAGES_AND_DEDUCTIBLES,
);
export const GET_COVERAGES_AND_DEDUCTIBLES_FAILURE = util.failureType(
  GET_COVERAGES_AND_DEDUCTIBLES,
);

export const REGISTER_PRODUCT_DEALER_CODE_REQUEST = util.requestType(
  REGISTER_PRODUCT_DEALER_CODE,
);
export const REGISTER_PRODUCT_DEALER_CODE_SUCCESS = util.successType(
  REGISTER_PRODUCT_DEALER_CODE,
);
export const REGISTER_PRODUCT_DEALER_CODE_FAILURE = util.failureType(
  REGISTER_PRODUCT_DEALER_CODE,
);

export const REGISTER_PRODUCT_AND_GET_COVERAGES_REQUEST = util.requestType(
  REGISTER_PRODUCT_AND_GET_COVERAGES,
);
export const REGISTER_PRODUCT_AND_GET_COVERAGES_SUCCESS = util.successType(
  REGISTER_PRODUCT_AND_GET_COVERAGES,
);
export const REGISTER_PRODUCT_AND_GET_COVERAGES_FAILURE = util.failureType(
  REGISTER_PRODUCT_AND_GET_COVERAGES,
);

export const REGISTER_PROVIDER_DEALER_CODE_REQUEST = util.requestType(
  REGISTER_PROVIDER_DEALER_CODE,
);
export const REGISTER_PROVIDER_DEALER_CODE_SUCCESS = util.successType(
  REGISTER_PROVIDER_DEALER_CODE,
);
export const REGISTER_PROVIDER_DEALER_CODE_FAILURE = util.failureType(
  REGISTER_PROVIDER_DEALER_CODE,
);

export const GET_AVAIL_PRODUCTS_FOR_BUNDLE_REQUEST = util.requestType(
  GET_AVAIL_PRODUCTS_FOR_BUNDLE,
);
export const GET_AVAIL_PRODUCTS_FOR_BUNDLE_SUCCESS = util.successType(
  GET_AVAIL_PRODUCTS_FOR_BUNDLE,
);
export const GET_AVAIL_PRODUCTS_FOR_BUNDLE_FAILURE = util.failureType(
  GET_AVAIL_PRODUCTS_FOR_BUNDLE,
);

export const ADD_PROVIDER_TO_DEALER_REQUEST = util.requestType(
  ADD_PROVIDER_TO_DEALER,
);
export const ADD_PROVIDER_TO_DEALER_SUCCESS = util.successType(
  ADD_PROVIDER_TO_DEALER,
);
export const ADD_PROVIDER_TO_DEALER_FAILURE = util.failureType(
  ADD_PROVIDER_TO_DEALER,
);
